import React from "react";
import * as LucideIcons from "lucide-react";

export default function BrandLogo({ cfg, accent, size = 36 }) {
  if (cfg.logoType === "custom_url" && cfg.logoCustomUrl) {
    return <img src={cfg.logoCustomUrl} alt="logo" style={{ height: size, width: size }} className="rounded-lg object-contain" />;
  }
  if (cfg.logoType === "icon") {
    const Icon = LucideIcons[cfg.logoIconName] || LucideIcons.Radio;
    return (
      <div
        style={{ height: size, width: size, background: accent.hex }}
        className="flex items-center justify-center rounded-lg text-slate-950 shadow-lg"
      >
        <Icon className="h-1/2 w-1/2" strokeWidth={2.5} />
      </div>
    );
  }
  return (
    <div
      style={{ height: size, width: size, background: accent.hex }}
      className="flex items-center justify-center rounded-lg font-bold text-slate-950 shadow-lg"
    >
      <span style={{ fontSize: size * 0.5 }} className="font-mono">{cfg.logoMonogramChar || "P"}</span>
    </div>
  );
}
